var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}.cls-1{stroke-linecap:square;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "withdrawl"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.5 1.5 22.5 11.04 17.73 11.04 17.73 6.27 6.27 6.27 6.27 11.04 1.5 11.04 1.5 1.5 22.5 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.27,
    y1: 6.27,
    x2: 17.73,
    y2: 6.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.27,
    y: 6.27,
    width: 11.45,
    height: 16.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 2.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.36,
    y1: 6.27,
    x2: 19.64,
    y2: 6.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12,
    y1: 16.77,
    x2: 12,
    y2: 19.64
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.efa8d888c414a1d39ae7a61d49a1c205.svg";
export { ForwardRef as ReactComponent };